module.exports = "/images/vendor/primevue/resources/color.png?c7a33805ffda0d32bd2a9904c8b02750";